import axios, { formDataRequest } from './axios'

export const getContractorSessions = () => axios.get('/contractor_session')

export const createContractorSession = data => axios.post('/contractor_session', data)
